import 'core-js/es6/set';

// import 'jquery';
// import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/sortable';
// import 'jquery-ui/ui/widgets/tooltip';
import 'jquery-zoom';

require('bootstrap');  // require as global not working.
import 'bootstrap/dist/css/bootstrap.css';

require('angular-bootstrap-toggle/src/angular-bootstrap-toggle');
require('angular-bootstrap-toggle/dist/angular-bootstrap-toggle.css');

global.bootbox = require('bootbox');

import 'angular';
import 'angular-route';
import 'angular-cookies';
import 'angular-vs-repeat';
import 'angular-bootstrap';
import 'angular-ui-grid';
import 'angular-ui-grid/ui-grid.tree-view';
import 'angular-ui-grid/ui-grid.resize-columns';
import 'angular-ui-grid/ui-grid.move-columns';
import 'angular-ui-grid/ui-grid.pinning';
import 'angular-ui-grid/ui-grid.grouping';
import 'angular-ui-grid/ui-grid.auto-resize';
import 'angular-ui-grid/ui-grid.css';

// angular.lowercase = text => text ? text.toLowerCase() : undefined;

import 'font-awesome/css/font-awesome.css';
// import 'highcharts/highstock';

global.Highcharts = require('highcharts/highcharts');
var highchartsDrilldown = require('highcharts/modules/drilldown');
highchartsDrilldown(global.Highcharts);
var highchartsMore = require('highcharts/highcharts-more');
highchartsMore(global.Highcharts);

global.accounting = require('accounting');
global._ = require('underscore');

// need verify
global.rangy = require('rangy');
global.rangy.saveSelection = require('rangy/lib/rangy-selectionsaverestore');

import 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';

import 'rx';
import 'rx-angular';

// angular-rich-text-diff missing

// Not using angular-ui-layout for some forgoten reason.
require('./lib/ui-layout/ui-layout.min');
require('./lib/ui-layout/ui-layout.css');

global.Common = require('./lib/smartorg/common.js');
require('./lib/smartorg/polyfill.js');

require('./lib/angular-neat-panel/angular-neat-layout');
require('./lib/angular-neat-panel/angular-neat-layout.css');

require('./lib/angular-neat-table/angular-neat-table.js');
require('./lib/angular-neat-table/angular-neat-table.css');

require('./lib/angular-rich-text-diff/angular-rich-text-diff');
require('./lib/angular-rich-text-diff/angular-rich-text-diff.css');

import 'angularjs-slider/dist/rzslider';
import 'angularjs-slider/dist/rzslider.css';

// require('./lib/angularjs-slider/build/rzslider.js');
// require('./lib/angularjs-slider/build/rzslider.css');

require('./lib/canvg/rgbcolor.js');
require('./lib/canvg/canvg.js');

global.saveAs = require('./lib/filesaver/FileSaver.js');
global.Parser = require('./lib/js-expression-eval/parser.js');
require('./lib/jquery-ui-touch-punch/jquery.ui.touch-punch.min.js');
// require('./lib/ui-bootstrap/ui-bootstrap-tpls-0.10.0.min.js');
require('./lib/ui-bootstrap/ui-bootstrap-tpls-0.13.0.min.js');
// require('./bower_components/angular-bootstrap/ui-bootstrap-tpls.min.js');
require('./lib/mctad.js/mctad.js');

global.Spinner = require('./lib/ios-overlay/js/spin.min');
global.iosOverlay = require('./lib/ios-overlay/js/iosOverlay');
require('./lib/ios-overlay/css/iosOverlay.css');


// WEBPACK FOOTER //
// ./app/vendors.js